import type { QueryHookOptions } from "@apollo/client"
import { useQuery } from "@apollo/client"
import query from "@/v2-backoffice-client/license/featureGroup/compose/license.featureGroup.contentCatalog.query.gql"
import { useFeatureGroupLens } from "@/v2-backoffice-client/license/featureGroup/compose/license.featureGroup.lens.context"
import { lensedCatalog } from "@/v2-backoffice-client/license/featureGroup/compose/license.featureGroup.lens.utils"
import type {
  FeatureContentCatalogQuery,
  FeatureContentCatalogQueryVariables,
} from "@/v2-backoffice-client/license/featureGroup/compose/__types__/license.featureGroup.contentCatalog.query"

type Options = QueryHookOptions<
  FeatureContentCatalogQuery,
  FeatureContentCatalogQueryVariables
>

/**
 * The content catalog as the current lens sees it: through the customer
 * lens a closed class reads as locked and "also in" names the customer's
 * own sources (license.featureGroup.lens.context). Every section reads
 * through here, so the lens applies once, to all of them. The package lens
 * hands the rows through untouched.
 */
export function useFeatureContentCatalogQuery(options?: Options) {
  const result = useQuery<
    FeatureContentCatalogQuery,
    FeatureContentCatalogQueryVariables
  >(query, options)
  const lens = useFeatureGroupLens()
  const through = (data: FeatureContentCatalogQuery | undefined) =>
    data && {
      getFeatureContentCatalog: lensedCatalog(
        data.getFeatureContentCatalog,
        lens,
      ),
    }
  return {
    ...result,
    data: through(result.data),
    previousData: through(result.previousData),
  }
}
